import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import ScrollProgress from "./components/ScrollProgress";
import Home from "./components/pages/Home";
import ProductenIndex from "./components/pages/ProductenIndex";
import ProductenDetail from "./components/pages/ProductenDetail";
import ScrollToTop from "./components/ScrollToTop";
import PageLoader from "./components/PageLoader"; // Import PageLoader
import Bestellen from "./components/pages/Bestellen";
import Aanvraag from "./components/pages/Aanvraag";
import Prijslijst from "./components/pages/Prijslijst";
import Portfolio from "./components/pages/Portfolio";
import Contact from "./components/pages/Contact";

// Add this proxy configuration
const proxyUrl = process.env.NODE_ENV === 'production' 
    ? 'https://www.wixapis.com'
    : '/api/';

// Export it so other components can use it
export const getApiUrl = (path) => `${proxyUrl}${path}`;

// The site used HashRouter until mid-2026; old links look like /#/producten.
// Translate them to real paths so bookmarks and indexed URLs keep working.
// Plain in-page anchors (#contact) must NOT redirect — hence the "#/" check.
function LegacyHashRedirect() {
	const navigate = useNavigate();
	useEffect(() => {
		if (window.location.hash.startsWith("#/")) {
			navigate(window.location.hash.slice(1), { replace: true });
		}
	}, [navigate]);
	return null;
}

// Add this function to handle hash navigation
function ScrollToHashElement() {
  const location = useLocation();
  
  useEffect(() => {
    // Check for hash in URL
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
    
    // Check for state from redirect
    if (location.state && location.state.scrollToContact) {
      const contactElement = document.getElementById('contact');
      if (contactElement) {
        setTimeout(() => {
          contactElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);
  
  return null;
}

// Fades each route in on navigation (keyed remount drives .route-fade).
function RouteTransition({ children }) {
	const location = useLocation();
	return (
		<div key={location.pathname} className="route-fade">
			{children}
		</div>
	);
}

function App() {
    return (
        <div className="App">
            <Router>
                <LegacyHashRedirect />
                <ScrollToTop />
                <ScrollToHashElement />
                <Navbar />
                <ScrollProgress />
                <PageLoader>
                    <RouteTransition>
                        <Routes>
                            <Route path="/" exact Component={Home} />
                            <Route path="/producten" exact Component={ProductenIndex} />
                            <Route path="/producten/:slug" Component={ProductenDetail} />
                            <Route path="/bestellen" exact Component={Bestellen} />
                            <Route path="/aanvraag" exact Component={Aanvraag} />
                            <Route path="/prijslijst" exact Component={Prijslijst} />
                            <Route path="/portfolio" exact Component={Portfolio} />
                            <Route path="/contact" exact Component={Contact} />
                        </Routes>
                    </RouteTransition>
                </PageLoader>
            </Router>
        </div>
    );
}

export default App;
